// api/WikiAPI.ts
import { registerQuery, registerSubscription } from "@adornis/baseql/metadata/register.js";
import { WikiEntryTemplate } from "../db/WikiEntry.js";
import { loadMongoData } from "@adornis/baseql/server/data-loader.js";
import { subscribeByID } from "@adornis/baseql/operations/mongo.js";
var wikiGetDefaultTemplateContent = registerQuery({
  type: () => String,
  operationName: "wikiGetDefaultTemplateContent",
  resolve: () => {
    return async () => {
      WikiEntryTemplate.ensureDefault();
      const res = await loadMongoData(WikiEntryTemplate, {
        _class: WikiEntryTemplate._class,
        _id: WikiEntryTemplate.DEFAULT_TEMPLATE_ID
      });
      return res[0]?.content ?? "";
    };
  },
  params: []
});
var wikiSubscribeDefaultTemplate = registerSubscription({
  type: () => [WikiEntryTemplate],
  operationName: "wikiSubscribeDefaultTemplate",
  resolve: () => {
    return (gqlFields) => {
      return subscribeByID(WikiEntryTemplate, WikiEntryTemplate.DEFAULT_TEMPLATE_ID)(gqlFields);
    };
  },
  params: []
});
var WikiAPI;
((WikiAPI2) => {
  WikiAPI2.getDefaultTemplateContent = wikiGetDefaultTemplateContent;
  WikiAPI2.subscribeDefaultTemplate = wikiSubscribeDefaultTemplate;
})(WikiAPI || (WikiAPI = {}));
export {
  WikiAPI
};
